import React, { Component } from 'react';
import {
  Carousel,
  UploadImageModal,
  UploadVideoModal,
  UploadDocumentModal,
  Loading
} from "common-import/custom";

import v from 'voca';
import moment from 'moment'
import { Link } from 'react-router-dom'
import { isEmpty, isEqual } from 'lodash';
import { MobXHelper, Request, VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";
import { HOST } from "common-import/constants";
import AsyncSelect from 'react-select/lib/Async';

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

const propertyProject = [
  "name",
  "description",
  "address",
  "country",
  "city",
  "district",
  "investmentType",
  "budget",
  "constructionArea",
  "landArea",
  "minStartTime",
  "maxStartTime",
  "minFinishTime",
  "maxFinishTime",
  "projectSubType",
  "projectType",
  "purpose",
  "state",
  "status"
];

@inject("projectStore", "userStore", "masterStore", "contractorStore", "participantStore", "companyInfoStore", "contactStore", "biddingCategoryStore", "routeStore") @observer
class ProjectDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      project: {},
      current: {},
      participants: [],
      currentParts: [],
      isLoading: true,
      enableEdit: false,
      isSaving: false,
      isApproving: false,
      isDeactivating: false,
      readMore: false,
      openVideoModal: false,
      openImageModal: false,
      openDocumentModal: false,
      enableAddNewParts: false,
      inputValue: '',
      isSearching: false,
      message: '',
      listCompany: [],
      listContact: [],
      newPart: {},
      isSavingParts: false,
      isSpecific: {
        budget: true,
        landArea: true,
        constructionArea: true
      },
      listBid: []
    };

    this.handleEnableEdit = this.handleEnableEdit.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    // this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleSubmitModal = this.handleSubmitModal.bind(this);
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    await this.getProjectDetail();
    await this.getParticipants();
    await this.getListBid();
    this.setState({ isLoading: false });
  }

  getListBid = async () => {
    const { current } = this.state;
    const { biddingCategoryStore } = this.props;
    const res = await biddingCategoryStore.getListWithProjectId({ projectId: current.id });
    if (!res.error) this.setState({ listBid: res.data })
  };

  getProjectDetail = async () => {
    const { projectStore, match } = this.props;
    let project = await projectStore.getProjectDetail(match.params.id);
    this.setState({
      project: VarHelper.cloneDeep(project),
      current: VarHelper.cloneDeep(project),
    });
  };

  getParticipants = async () => {
    const { participantStore } = this.props;
    const { current } = this.state;
    const participants = await participantStore.getList(current.id);
    this.setState({
      participants: VarHelper.cloneDeep(participants),
      currentParts: VarHelper.cloneDeep(participants),
    });
  };

  approveProject = async e => {
    !!e && e.preventDefault();
    const { projectStore, match } = this.props;
    const { current } = this.state;
    const continueApprove = window.confirm("Are you sure want to approve this project?");
    if (continueApprove) {
      this.setState({ isApproving: true });
      let result = await projectStore.approve({ id: match.params.id, approved: true });
      this.setState({ isApproving: false });
      if (!!result.error) {
        return window.toast.error(JSON.stringify(result.error));
      }
      current.approved = 1;
      this.setState({
        project: current,
        current,
      });
      return window.toast.info("Approved successfully.");
    }
  };

  deactivateProject = async e => {
    !!e && e.preventDefault();
    const { projectStore, match } = this.props;
    const { current } = this.state;
    const continueApprove = window.confirm("Are you sure want to DEACTIVATE this project?");
    if (continueApprove) {
      this.setState({ isDeactivating: true });
      let result = await projectStore.deactive(match.params.id);
      this.setState({ isDeactivating: false });
      if (!!result.error) {
        return window.toast.error(JSON.stringify(result.error));
      }
      current.approved = 2;
      this.setState({
        project: current,
        current,
      });
      return window.toast.info("DEACTIVATED successfully.");
    }
  };

  renderApprove = () => {
    const { isApproving, isDeactivating } = this.state;
    const { approved } = this.state.current;
    if (approved === undefined || approved === "" || approved === true || approved === 1) {
      return (
        <div className="approve-request-section">
          <h3 className="text">Deactivate this project </h3>
          <button className="btn btn-sm btn-danger" disabled={isDeactivating} onClick={this.deactivateProject}>
            <i className="fa fa-dot-circle-o"> </i> {isDeactivating ? 'Deactivating...' : 'Deactivate'}
          </button>
        </div>
      )
    }
    return (
      <div className="approve-request-section">
        <h3 className="text">This project is not approved </h3>
        <button className="btn btn-sm btn-primary" disabled={isApproving} onClick={this.approveProject}>
          <i className="fa fa-dot-circle-o"> </i> {isApproving ? 'Approving...' : 'Approve'}
        </button>
      </div>
    )
  };

  renderCreator = (project) => {
    if (project && project.hasOwnProperty('createdByUser')) {
      const creator = project.createdByUser;
      return (
        <div className="block-content">
          <h4 className="block-content__title">Creator</h4>
          <div className="media user">
            <div className="media-left user-avatar"
              style={{ backgroundImage: `url(${VarHelper.img(creator.avatar) || defaultImage})` }}>
            </div>
            <div className="media-body">
              <h4 className="media-heading">{creator.name}</h4>
              <p className="user__phone">
                <i className="fa fa-phone-square" aria-hidden="true"> </i> {creator.phone}
              </p>
              <p className="user__email">
                <i className="fa fa-envelope" aria-hidden="true"> </i> {creator.email}
              </p>
              <p className="user__created-date">
                <strong>Created at:</strong> {moment(project.createdAt).format('LL')}
              </p>
              <p className="user__update-date">
                <strong>Last update:</strong> {moment(project.updatedAt).format('LL')}
              </p>
            </div>
          </div>
        </div>
      )
    }
  };

  renderGeneral = (project) => {
    const { listBid } = this.state;

    if (project && project.id) {
      const { readMore } = this.state;
      const { toValue, project_type, project_state_status } = this.props.masterStore;
      let { description } = project;
      description = !!description ? description : '';

      return (
        <div className="block-content general">
          <h4 className="block-content__title">General</h4>
          <div className="general__content">
            <h5 className="name">{project.name}</h5>
            <p className="description">
              {VarHelper.readMoreString(description, readMore, 200)}
              <a style={{ display: description.length > 200 ? 'inline' : 'none' }}
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({ readMore: !this.state.readMore });
                }}
                href="#"
              >
                Show {readMore ? 'less' : 'more'}
              </a>
            </p>
            <p className="address">
              <i className="fa fa-map-marker" aria-hidden="true"> </i>
              {project.address}
            </p>
            <p className="project-type">
              <i className="fa fa-file-o" aria-hidden="true"> </i>
              {toValue(project_type, project.projectType)}
            </p>
            <p className="project-status">
              <i className="fa fa-dot-circle-o" aria-hidden="true"> </i>
              {toValue(project_state_status, project.status)}
            </p>
            <div style={{ marginTop: '8px' }}>
              Bidding list:
              <ul>
                {
                  listBid.map((item, index) => <li key={'bidId' + index}><Link to={`/bidding/${item.id}?name=${item.name}`} />{item.id}</li>)
                }
              </ul>
            </div>
          </div>
        </div>
      )
    }
  };

  renderBidding = (project) => {
    if (project && project.id) {
      const { enableEdit } = this.state;
      const cls = enableEdit ? 'block-content bidding' : 'block-content bidding split-preview';

      const {
        toValue,
        project_type,
        project_sub_type,
        project_work_type,
        project_state_status,
        project_state,
        project_investment_type,
        project_investment_type_app,
        project_purpose,
        project_budget,
        project_construction_area,
        project_land_area
      } = this.props.masterStore;

      const data = [
        { label: 'Budget', value: VarHelper.textMoney(project.minBudget) + '-' + VarHelper.textMoney(project.maxBudget) },
        { label: 'Start', value: moment(project.minStartTime).format('ll') },
        { label: 'Finish', value: moment(project.maxFinishTime).format('ll') },
        { label: 'Type', value: toValue(project_type, project.projectType) },
        { label: 'Sub-type', value: toValue(project_sub_type, project.projectSubType) },
        { label: 'Work type', value: toValue(project_work_type, project.workType) },
        { label: 'Investment type', value: toValue(project_investment_type_app, project.investmentType) },
        { label: 'State', value: toValue(project_state, project.state) },
        { label: 'Status', value: toValue(project_state_status, project.status) },
        { label: 'Purpose', value: toValue(project_purpose, project.purpose) },
        { label: 'Construction area', value: toValue(project_construction_area, project.minConstructionArea) + ' - ' + toValue(project_construction_area, project.maxConstructionArea) },
        { label: 'Land area', value: toValue(project_land_area, project.minLandArea) + ' - ' + toValue(project_land_area, project.maxLandArea) },
      ];

      const renderDetails = () => {
        return data.map((item, index) => {
          return <div key={item.label + index} className="raw-group">
            <span className="key">{item.label}</span>
            <span className="string"> </span>
            <span className="value">{item.value}</span>
          </div>
        })
      };

      return (
        <div className={cls}>
          <h4 className="block-content__title">Others</h4>
          <div className="bidding__content">
            <div className="bidding__detail">
              {renderDetails()}
            </div>
          </div>
        </div>
      )
    }
  };

  renderEditForm = (project) => {
    const {
      toValue,
      toSelectData,
      project_type,
      project_sub_type,
      project_work_type,
      project_state_status,
      project_state,
      project_status,
      project_investment_type,
      project_investment_type_app,
      project_purpose,
      project_budget,
      project_construction_area,
      project_land_area,
      country, city, district
    } = this.props.masterStore;

    const propMaster = {
      projectType: project_type,
      projectSubType: project_sub_type,
      workType: project_work_type,
      investmentType: project_investment_type_app,
      purpose: project_purpose,
      status: project_state_status,
      state: project_state,
      country: country,
      district: district,
      city: city,
      budget: project_budget,
      landArea: project_land_area,
      constructionArea: project_construction_area
    };

    const renderOptions = (prop) => {
      const arr = [{ id: 'null', label: '', value: 'null' }, ...toSelectData(propMaster[prop])];
      return arr.map((item, index) => {
        return (
          <option key={`${prop}${index}${item.id}`} value={item.id}>{item.label}</option>
        )
      })
    };

    const handleSpecialField = (property) => {
      let defaultValue = '';
      let firstFieldName, secondFieldName;
      if (property === "budget") {
        firstFieldName = "minBudget";
        secondFieldName = "maxBudget";
        defaultValue = this.state.current.minBudget + '-' + this.state.current.maxBudget
      } else if (property === "landArea") {
        firstFieldName = "minLandArea";
        secondFieldName = "maxLandArea";
        defaultValue = this.state.current.minLandArea + '-' + this.state.current.maxLandArea
      } else if (property === "constructionArea") {
        firstFieldName = "minConstructionArea";
        secondFieldName = "maxConstructionArea";
        defaultValue = this.state.current.minConstructionArea + '-' + this.state.current.maxConstructionArea
      } else {
        defaultValue = this.state.current[property]
      }
      return <div className="position-relative form-group">
        <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
        <select
          id={"nf-" + property}
          name={"nf-" + property}
          className="form-control"
          defaultValue={defaultValue}
          onChange={e => {
            if (toValue(propMaster[property], e.target.value).includes("___")) {
              this.setState({ isSpecific: { ...this.state.isSpecific, [property]: true } })
            } else {
              this.setState({
                isSpecific: { ...this.state.isSpecific, [property]: false },
              });
              if (property === "purpose") {
                this.setState({
                  current: { ...this.state.current, [property]: e.target.value }
                })
              } else {
                this.setState({
                  current: { ...this.state.current, ...VarHelper.getSpecificMinMax(toValue(propMaster[property], e.target.value), firstFieldName, secondFieldName) }
                })
              }
            }
          }}
        >
          {renderOptions(property)}
        </select>
        {this.state.isSpecific[property] ?
          <input type="text"
            className="form-control"
            id={"nfi-" + property}
            name={"nfi-" + property}
            defaultValue={defaultValue}
            onChange={e => {
              if (property === "purpose") {
                this.setState({
                  current: { ...this.state.current, [property]: e.target.value }
                })
              } else if (!!VarHelper.getSpecificMinMax(e.target.value, firstFieldName, secondFieldName)) {
                this.setState({
                  current: { ...this.state.current, ...VarHelper.getSpecificMinMax(e.target.value, firstFieldName, secondFieldName) }
                })
              }
            }}
          />
          : ''
        }
      </div>
    };

    if (project) {
      return (
        <form className="block-content">
          <h4 className="block-content__title">
            <i className="fa fa-pencil" aria-hidden="true"> </i>
            Edit project information
          </h4>
          <div className="row">
            {
              propertyProject.map((property, index) => {
                let element;
                if (property === 'description') {
                  element = <div className="position-relative form-group">
                    <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                    <textarea
                      className="form-control"
                      id={"nf-" + property}
                      name={"nf-" + property}
                      defaultValue={this.state.current[property] || ''}
                      onChange={e => this.setState({
                        current: { ...this.state.current, [property]: e.target.value }
                      })}
                      placeholder={v.capitalize(property)}
                    />
                  </div>
                } else if (["projectType", "projectSubType", "workType", "investmentType", "country", "state", "status"].indexOf(property) !== -1) {
                  element = <div className="position-relative form-group">
                    <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                    <select
                      id={"nf-" + property}
                      name={"nf-" + property}
                      className="form-control"
                      defaultValue={this.state.current[property]}
                      onChange={e => this.setState({
                        current: { ...this.state.current, [property]: e.target.value }
                      })}
                      placeholder={v.capitalize(property)}
                    >
                      {renderOptions(property)}
                    </select>
                  </div>
                } else if (["budget", "landArea", "constructionArea", "purpose"].indexOf(property) !== -1) {
                  // ====== ABC xyz ======== //
                  element = handleSpecialField(property)
                } else if (["minStartTime", "maxStartTime", "minFinishTime", "maxFinishTime"].indexOf(property) !== -1) {
                  element = <div className="position-relative form-group">
                    <label htmlFor={"nf-" + property}>{v.capitalize(property)} <span className="small text-muted">format(YYYY-MM-DD)</span></label>
                    <input
                      type="text"
                      className="form-control"
                      id={"nf-" + property}
                      name={"nf-" + property}
                      defaultValue={moment(this.state.current[property]).format('YYYY-MM-DD')}
                      onChange={e => this.setState({
                        current: { ...this.state.current, [property]: e.target.value }
                      })}
                      placeholder={v.capitalize(property)}
                    />
                  </div>
                } else {
                  element = <div className="position-relative form-group">
                    <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                    <input
                      type="text"
                      className="form-control"
                      id={"nf-" + property}
                      name={"nf-" + property}
                      defaultValue={this.state.current[property] === null ? '' : this.state.current[property]}
                      onChange={e => this.setState({
                        current: { ...this.state.current, [property]: e.target.value }
                      })}
                      placeholder={v.capitalize(property)}
                    />
                  </div>
                }

                return (
                  <div className="col-md-6" key={"property" + index}>
                    {element}
                  </div>
                );
              })
            }
          </div>
        </form>
      )
    }
  };

  search = async (e) => {
    !!e && e.preventDefault();
    const { contractorStore } = this.props;
    const { inputValue } = this.state;
    const isNumber = !isNaN(inputValue);
    const findObject = isNumber ? { taxId: inputValue } : { name: inputValue };
    this.setState({ isSearching: true });
    let companyResult = await contractorStore.searchByName(findObject);
    this.setState({ isSearching: false });
    if (!!companyResult.error) {
      return window.toast.error(JSON.stringify(companyResult.error));
    }
    this.setState({ listCompany: companyResult.data, message: companyResult.data.length > 0 ? "" : "Company not found." })
  };

  findContact = async ({ name, taxCode }) => {
    const { contactStore } = this.props;
    let res = await contactStore.getContactList(taxCode);
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    this.setState({
      listContact: res.data,
      message: res.data.length === 0 ? `${name} has no contact now` : `Display ${res.data.length} contacts of ${name}`
    });
  };

  renderCompanyList = () => {
    const { listCompany } = this.state;
    return (
      <div style={{ maxHeight: 256, overflow: "auto", marginBottom: 20 }}>
        {listCompany.map((val, index) => (
          <p className="cursor hover-underline" key={"comp" + index} onClick={() => {
            this.setState({
              newPart: {
                ...this.state.newPart,
                participantId: val.id,
                name: val.name,
              }
            });
            this.findContact(val);
          }}>{val.name}</p>
        ))}
      </div>
    )
  };

  renderAddNewParticipant = () => {
    const { message, isSearching, listContact, isSavingParts } = this.state;
    const { toSelectData, project_company_role } = this.props.masterStore;
    const renderOptions = (prop) => {
      const arr = [{ id: null, value: '', label: '' }, ...toSelectData(project_company_role)];
      return arr.map((item, index) => {
        return (
          <option key={`${prop}${index}${item.id}`} value={item.id}>{item.label}</option>
        )
      })
    };
    return (
      <div className="card add-new-participant">
        <div className="card-body">
          <div className="input-group" style={{ marginBottom: '16px' }}>
            <input type="text" placeholder="companyName or CompanyTaxCode" className="form-control"
              onChange={(e) => this.setState({ inputValue: e.target.value })}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  this.search(e);
                }
              }}
            />
            <div className="input-group-append">
              <button onClick={(e) => this.search(e)} type="button" className="btn btn-primary" disabled={isSearching}>
                {isSearching ? 'Searching...' : 'Search'}
              </button>
            </div>
          </div>
          {this.renderCompanyList()}
          {!!message ? <p className="text-success" style={{ marginBottom: '16px' }}>{message}</p> : ''}
          {this.renderContacts(listContact, true)}
          <label>Role</label>
          <select className="form-control"
            onChange={(e) => {
              this.setState({ newPart: { ...this.state.newPart, role: e.target.value } });
            }}
          >
            {renderOptions()}
          </select>
        </div>
        <div className="card-footer">
          <button className="btn btn-sm btn-primary" disabled={isSavingParts}
            onClick={(e) => this.addParticipant(e)}
          >{isSavingParts ? 'Saving...' : 'Save'}</button>
          <button className="btn btn-sm btn-danger"
            onClick={(e) => {
              e.preventDefault();
              this.setState({
                listCompany: [],
                listContact: [],
                newPart: {},
                message: '',
                enableAddNewParts: false,
                isSavingParts: false,
              });
            }}
          >Cancel</button>
        </div>
      </div>
    )
  };

  renderParticipants = () => {
    const { currentParts } = this.state;
    const { toValue, project_company_role } = this.props.masterStore;
    return (
      <div className="block-content participants">
        <h4 className="block-content__title">Participants</h4>
        {this.state.enableAddNewParts ? '' :
          <div className="buttons" style={{ marginBottom: '24px' }}>
            <button className="btn btn-sm btn-primary"
              onClick={(e) => {
                e.preventDefault();
                this.setState({ enableAddNewParts: true });
              }}
            >
              <i className="fa fa-plus"> </i> Add new
          </button>
          </div>
        }
        {this.state.enableAddNewParts ? this.renderAddNewParticipant() : ''}
        <div className="participants__list">
          {
            (currentParts || []).map((item, index) => {
              return (
                <div key={index} className="participant">
                  <div className="participant__header">
                    <div className="participant__text">
                      <h5 className="participant__role">{toValue(project_company_role, item.role)}</h5>
                      <h4 className="participant__name">{item.name}</h4>
                    </div>
                    {
                      !!item.editing
                        ?
                        <div className="participant__control">
                          <button className="btn btn-sm btn-default" onClick={e => this.cancelEditParticipant(e, item)}>Cancel</button>
                          <button className="btn btn-sm btn-primary" disabled={!!item.saving} onClick={e => this.saveChangeParticipant(e, item)}>{!!item.saving ? 'Saving...' : 'Save'}</button>
                        </div>
                        :
                        <div className="participant__control">
                          <button className="btn btn-sm btn-primary" onClick={e => this.enableEditParticipant(e, item)}>Edit</button>
                          <button className="btn btn-sm btn-danger" disabled={!!item.deleting} onClick={e => this.deleteParticipant(e, item)}>{!!item.deleting ? 'Deleting...' : 'Delete'}</button>
                        </div>
                    }
                  </div>
                  <div className="participant__contacts">
                    {!!item.message ? <p className="text-success" style={{ margin: '16px 0', textAlign: 'center' }}>{item.message}</p> : ''}
                    {!!item.editing ? this.renderContacts(item.contacts, true, false, item.participantId) : this.renderContacts(item.contacts)}
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  };

  renderContacts = (contacts = [], minimize = false, addNew = true, participantId = null) => {
    return (
      <div className="row">
        {
          contacts.map((item, index) => {
            return (
              <div key={index} className="col-md-6">
                <div className="media user contact block-content">
                  <div className="media-left user-avatar"
                    style={{ backgroundImage: `url(${VarHelper.img(item.avatar) || defaultImage})` }}>
                  </div>
                  <div className="media-body">
                    <h4 className="media-heading">{item.name}</h4>
                    <p className="user__position">{item.position}</p>
                    {minimize ?
                      <div className="user__button" style={{ textAlign: 'right' }}>
                        <button className={!!item.added ? 'btn btn-sm btn-danger' : 'btn btn-sm btn-primary'}
                          onClick={e => addNew ? this.handleSelectContact(e, item.id) : this.handleSelectContact(e, item.id, participantId)}
                        >
                          {!!item.added ? 'unselect' : 'select'}
                        </button>
                      </div>
                      :
                      <div>
                        <p className="user__phone">
                          <i className="fa fa-phone-square" aria-hidden="true"> </i> {item.phone}
                        </p>
                        <p className="user__email">
                          <i className="fa fa-envelope" aria-hidden="true"> </i> {item.email}
                        </p>
                      </div>}
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    )
  };

  handleSelectContact = (e, id, participantId = null) => {
    e.preventDefault();
    if (!participantId) {
      const list = this.state.listContact.map((item) => {
        if (item.id === id) item.added = !item.added;
        return item;
      });
      this.setState({ listContact: list });
    } else {
      const { currentParts } = this.state;
      const pa = currentParts.find(item => item.participantId === participantId);
      pa.contacts.map((item) => {
        if (item.id === id) item.added = !item.added;
        return item;
      });
      currentParts.map((item) => {
        if (item.participantId === participantId) item = pa;
        return item;
      });
      this.setState({ currentParts });
    }
  };

  cancelEditParticipant = (e, { participantId }) => {
    !!e && e.preventDefault();
    const { currentParts, participants } = this.state;
    const list = currentParts.map((item, index) => {
      if (item.participantId === participantId) {
        item.editing = false;
        item.message = '';
        item.contacts = participants[index].contacts;
      }
      return item;
    });
    this.setState({ currentParts: list });
  };

  enableEditParticipant = async (e, { participantId }) => {
    !!e && e.preventDefault();
    const { contractorStore, contactStore } = this.props;
    const { currentParts } = this.state;

    for (let i = 0; i < currentParts.length; i++) {
      if (currentParts[i].participantId === participantId) {
        currentParts[i].editing = true;

        currentParts[i].contacts.map(itm => {
          itm.added = true; return itm;
        });

        currentParts[i].message = 'Loading more contact...';
        this.setState({ currentParts });
        const res = await contractorStore.detail(participantId);
        if (!res.error) {
          const res2 = await contactStore.getContactList(res.data.taxCode);
          currentParts[i].contacts = VarHelper.getNewArrayCompared(currentParts[i].contacts, res2.data, 'id');
        }
        currentParts[i].message = '';

        break;
      }
    }
    this.setState({ currentParts });
  };

  saveChangeParticipant = async (e, { participantId }) => {
    !!e && e.preventDefault();
    const { currentParts } = this.state;
    const { participantStore } = this.props;

    currentParts.map(item => {
      if (item.participantId === participantId) {
        item.saving = true;
      }
      return item;
    });
    this.setState({ currentParts });

    const pa = currentParts.find(item => item.participantId === participantId);
    // pa.hasOwnProperty('editing') ? delete pa.editing : null;
    // pa.hasOwnProperty('saving') ? delete pa.saving : null;
    // pa.hasOwnProperty('deleting') ? delete pa.deleting : null;

    const contacts = pa.contacts.filter(item => item.added === true);
    const payload = {
      name: pa.name,
      participantType: pa.participantType,
      participantId: pa.participantId,
      projectId: pa.projectId,
      role: pa.role,
      contacts,
    };
    const res = await participantStore.create(payload);

    currentParts.map(item => {
      if (item.participantId === participantId) {
        item.saving = false;
        item.editing = false;
      }
      return item;
    });
    this.setState({ currentParts });

    if (!!res.error) {
      return window.toast.error(JSON.stringify(res.error));
    }

    window.toast.info('Updated participant successfully!');

    currentParts.map(item => {
      if (item.participantId === participantId) {
        item = { ...pa, contacts }
      }
      return item;
    });
    this.setState({ currentParts });
  };

  addParticipant = async (e) => {
    !!e && e.preventDefault();
    const { participantStore } = this.props;
    const { newPart, listContact, project } = this.state;
    const contacts = listContact.filter(item => item.added === true);
    const payload = {
      ...newPart,
      contacts,
      participantType: "contractor",
      projectId: project.id
    };
    this.setState({ isSavingParts: true });
    const res = await participantStore.create(payload);
    this.setState({ isSavingParts: false });
    if (!!res.error) {
      return window.toast.error(JSON.stringify(res.error));
    }
    window.toast.info('Added successfully!');
    this.setState({
      listCompany: [],
      listContact: [],
      newPart: {},
      message: ''
    });
    await this.getParticipants();
  };

  deleteParticipant = async (e, { participantId, participantType, projectId, name }) => {
    !!e && e.preventDefault();
    const { participantStore } = this.props;
    const { participants } = this.state;

    participants.map(item => {
      if (item.participantId === participantId) item.deleting = true;
      return item;
    });
    this.setState({ participants });

    const payload = {
      participantType,
      participantId,
      projectId,
    };
    const confirmDelete = window.confirm("Are you sure want to delete " + name);
    if (!confirmDelete) return null;
    const res = await participantStore.delete(payload);
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    window.toast.info('Deleted successfully!');
    const newList = participants.filter(item => item.participantId !== participantId);
    this.setState({
      participants: newList,
      currentParts: newList,
    });
  };

  formatPayload = (data) => {
    let copy;

    const typeFormat = {
      typeObject: ["location"],
      typeArray: ["documents", "listVideos", "listImages"],
      typeDate: ["minStartTime", "maxStartTime", "minFinishTime", "maxFinishTime"],
      typeNumber: ["minBudget", "maxBudget", "minConstructionArea", "maxConstructionArea", "minLandArea", "maxLandArea", "totalFloorArea"],
      typeString: ["name", "description", "projectType", "projectSubType", "workType", "address", "village", "district", "city", "country", "investmentType", "state", "status", "purpose"]
    };

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  handleEnableEdit = (e) => {
    e.preventDefault();
    this.setState({ enableEdit: true })
  };

  handleCloseModal = () => {
    this.setState({
      openVideoModal: false,
      openImageModal: false,
      openDocumentModal: false
    });
  };

  handleOpenModal = (type) => {
    this.setState({
      openVideoModal: type === 'video',
      openImageModal: type === 'image',
      openDocumentModal: type === 'document'
    });
  };

  handleSubmitModal = async (list) => {
    const { current, openImageModal, openVideoModal, openDocumentModal } = this.state;

    if (openVideoModal) {
      this.setState({ current: { ...current, listVideos: [...list] } });
    } else if (openImageModal) {
      this.setState({ current: { ...current, listImages: [...list] } });
    } else if (openDocumentModal) {
      this.setState({ current: { ...current, documents: [...list] } });
    }

    this.setState({
      openImageModal: false,
      openVideoModal: false,
      openDocumentModal: false,
    });
  };

  cancelEdit = (e) => {
    e.preventDefault();
    const { project, current } = this.state;
    if (!isEqual(current, project)) {
      if (!window.confirm('Are you sure want to cancel the changes?')) return null;
      this.setState({
        enableEdit: false,
        current: VarHelper.cloneDeep(project),
      })
    }
    this.setState({ enableEdit: false });
  };

  saveChanges = async () => {
    const { projectStore, match } = this.props;
    const { current } = this.state;
    const payload = this.formatPayload(current);
    payload["location"] = await VarHelper.getLatLngFromAddress(payload.address);
    payload["totalFloorArea"] = payload.maxLandArea + payload.maxConstructionArea;

    this.setState({ isSaving: true });
    const res = await projectStore.update(payload);
    this.setState({ isSaving: false });

    if (!!res.error) {
      return window.toast.error(JSON.stringify(res.error));
    }

    this.setState({
      project: VarHelper.cloneDeep(res.data),
      current: VarHelper.cloneDeep(res.data),
    });

    window.toast.info('Updated successfully.');

    const resApprove = await projectStore.approve({ id: match.params.id, approved: true });
    if (!resApprove.error) {
      this.setState({
        project: { ...this.state.current, approved: 1 },
        current: { ...this.state.current, approved: 1 },
      });
    }
  };

  renderUploadForm = () => {
    const { current } = this.state;
    return (
      <div className="block-content">
        <div className="block-content__title">
          <span><i className="fa fa-file"> </i> Images & Videos & Documents</span>
        </div>
        <div className="block-content__body">
          {/*images*/}
          <label>Images ({(current.listImages || []).length})</label>
          <div className="input-group" style={{ marginBottom: '16px' }}>
            <input type="text" disabled={true} className="form-control"
              value={!!current.listImages ? current.listImages.join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('image')}>Edit</button>
            </div>
          </div>
          {/*videos*/}
          <label>Videos ({(current.listVideos || []).length})</label>
          <div className="input-group" style={{ marginBottom: '16px' }}>
            <input type="text" disabled={true} className="form-control" placeholder="Video list"
              value={!!current.listVideos ? current.listVideos.join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('video')}>Edit</button>
            </div>
          </div>
          {/*documents*/}
          <label>Documents ({(current.documents || []).length})</label>
          <div className="input-group" style={{ marginBottom: '16px' }}>
            <input type="text" disabled={true} className="form-control"
              value={!!current.documents ? current.documents.map(item => item.url).join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('document')}>Edit</button>
            </div>
          </div>
        </div>
      </div>
    )
  };

  render = () => {
    const { current, enableEdit, isSaving, openVideoModal, openImageModal, openDocumentModal, isLoading } = this.state;
    const { routeStore } = this.props;

    if (isLoading) return (<Loading> </Loading>);

    let content = '';
    let listImages = [];

    if (current.hasOwnProperty('listImages')) {
      const newList = current.listImages.slice();
      for (let i = 0; i < newList.length; i++) {
        if (!!newList[i]) {
          const item = {
            src: VarHelper.img(newList[i]),
            altText: '',
            caption: '',
          };
          listImages.push(item);
        }
      }
    }

    if (enableEdit) {
      content = <div className="card">
        <div className="card-header">
          <div className="card-header-left">
            <i className="fa fa-envelope-open"> </i> Bidding detail: <strong>{current.name}</strong>
          </div>
          <div className="card-header-right">
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-6">
              {this.renderEditForm(current)}
            </div>
            <div className="col-md-6">
              {this.renderGeneral(current)}
              {this.renderBidding(current)}
              {this.renderUploadForm()}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="button-group">
            <button className="btn btn-sm btn-primary" disabled={isSaving} onClick={this.saveChanges}>
              <i className="fa fa-dot-circle-o"> </i> {isSaving ? 'Saving' : 'Save'}
            </button>
            <button className="btn btn-sm btn-danger" onClick={this.cancelEdit}>
              <i className="fa fa-ban"> </i> Cancel
            </button>
          </div>
        </div>
      </div>
    } else {
      content = <div className="card">
        <div className="card-header">
          <div className="card-header-left">
            <i className="fa fa-envelope-open"> </i> Bidding detail: <strong>{current.name}</strong>
          </div>
          <div className="card-header-right">
            <div className="button-group">
              <a target="_blank" href={routeStore.web.projectDetail(current.id, current.name)}>
                <button className="btn btn-sm btn-primary" style={{ marginRight: 10 }}>
                  <i className="fa fa-chrome"> </i> Mở bên web
                </button>
              </a>
              <button className="btn btn-sm btn-primary" onClick={this.handleEnableEdit}>
                <i className="fa fa-pencil" aria-hidden="true"> </i> Edit
              </button>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              {/*images*/}
              <div className="block-content">
                <h3 className="block-content__title">Images ({(listImages || []).length})</h3>
                {listImages.length > 1 ? <Carousel items={listImages} /> : ''}
                {listImages.length === 1 ? <div className="project-detail-image"><img src={listImages[0].src} alt="" /></div> : ''}
              </div>
              {/*documents*/}
              <div className="block-content">
                <h3 className="block-content__title">Documents ({(current.documents || []).length})</h3>
                {(current.documents || []).map((item, index) => <a target="_blank" key={'docs' + index} href={item.url}>document {index + 1}</a>)}
              </div>
              {/*creator*/}
              {this.renderCreator(current)}
            </div>
            <div className="col-md-6">
              {/*videos*/}
              <div className="block-content">
                <h3 className="block-content__title">Videos ({(current.listVideos || []).length})</h3>
                <div className="video-block">
                  <div className="embed-container">
                    <iframe src={VarHelper.toEmbedYoutube(!!current.listVideos ? current.listVideos[0] : '') || ' '} frameBorder="0" allowFullScreen> </iframe>
                  </div>
                </div>
              </div>
              {/*general information*/}
              {this.renderGeneral(current)}
            </div>
          </div>
          {/**/}
          {this.renderBidding(current)}
          {this.renderParticipants()}
          {/**/}
        </div>
        <div className="card-footer">
          {this.renderApprove()}
          <button className="btn btn-sm btn-default" onClick={() => this.props.history.goBack()}>
            <i className="fa fa-long-arrow-left"> </i> Go back
          </button>
        </div>
      </div>
    }

    return (
      <div id="project-detail" className="animated fadeIn">
        {this.renderApprove()}
        <UploadVideoModal
          open={openVideoModal}
          list={current.listVideos || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        >
        </UploadVideoModal>
        <UploadImageModal
          open={openImageModal}
          list={current.listImages || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        >
        </UploadImageModal>
        <UploadDocumentModal
          open={openDocumentModal}
          list={current.documents || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        >
        </UploadDocumentModal>
        {/*content*/}
        <div>{content}</div>
      </div>
    );
  }
}

export default ProjectDetail;



// WEBPACK FOOTER //
// ./src/views/Projects/Detail.js